(function () {
  /*
   * about-amj-reveal.js
   * Shared scroll-reveal handler for all About AMJ sections.
   *
   * Guard: only the first copy that runs initialises the observer.
   * All other sections that load this same file return immediately because
   * the browser caches and deduplicates the script by URL.
   */
  if (window.amjRevealReady) return;
  window.amjRevealReady = true;

  var obs = null;

  if ('IntersectionObserver' in window) {
    obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  }

  function observeAll(container) {
    var els = (container || document).querySelectorAll('.amj-reveal');
    if (!obs) {
      /* No IntersectionObserver support: show everything immediately */
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    els.forEach(function (el) { obs.observe(el); });
  }

  /* Initial page load */
  document.addEventListener('DOMContentLoaded', function () {
    observeAll();
  });

  /*
   * Shopify theme customizer: fires every time a section is re-rendered
   * (e.g. when an image picker, text, or any setting changes).
   * Without this, freshly rendered .amj-reveal elements start at opacity:0
   * and never get observed, so the section looks blank after an edit.
   */
  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = document.getElementById(
      'shopify-section-' + event.detail.sectionId
    );
    if (sectionEl) observeAll(sectionEl);
  });
}());
